import type { EntityOption } from '@/components/EntitySelect';
import { getCourse, listCourses } from './api';

/** Server search for the course picker (EntitySelect). */
export async function searchCourses(query: string): Promise<EntityOption[]> {
  const page = await listCourses({ search: query || undefined });
  return page.results.map((c) => ({ value: String(c.id), label: c.title }));
}

/** Resolve a course's title for a preselected id (edit mode). */
export async function resolveCourseLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const course = await getCourse(Number(value));
  return course.title;
}
